import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { ProcessCardWidget } from "./ProcessCard.jsx";
import { SkeletonCarousel } from "./SkeletonCarousel.jsx";

export function ProcessListWidget({ configuration }) {
  const [processes, setProcesses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false); 


  useEffect(() => {
    getProcesses();
  }, []);

  const headers = {
    "Accept-Language": window.location.pathname.split("/")[1],
  };

  const getProcesses = async () => {
    setIsLoading(true);
    fetch(configuration.endpoint, { headers: headers })
      .then((response) => response.json())
      .then((data) => {
        setProcesses(data.results);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // Función para manejar el click en una tarjeta
  const handleCardClick = (e, process) => {
    if (isLoading) return; 

    if (!process.accesible.status) {
      
      e.preventDefault();
      e.stopPropagation();
      setIsModalOpen(true);
      return;
    }

    
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  let title;
  if (configuration.finished) {
    title = configuration.translations.finishedProcesses;
  } else if (configuration.future) {
    title = configuration.translations.futureProcesses;
  } else if (configuration.mine) {
    title = configuration.translations.myProcesses;
  } else {
    title = configuration.translations.activeProcesses;
  }

  let out;
  if (processes.length > 0) {
    out = (
      <div>
        <div className="titulo">{title}</div>

        <Slider
          {...configuration.settings}
          infinite={processes.length > configuration.settings.slidesToShow}
        >
          {processes.map((process) => (
            <div key={process.pk} onClick={(e) => handleCardClick(e, process)}>
              <ProcessCardWidget
                process={process}
                configuration={configuration}
              />
            </div>
          ))}
        </Slider>
      </div>
    );
  } else {
    out = "";
  }

  return (
    <>
      {isLoading ? <SkeletonCarousel /> : out}

      {/* Modal */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h2>{configuration.translations.forbiddenProcess}</h2>
            <p>{configuration.translations.forbiddenProcessExplication}</p>
            <span>{configuration.translations.forbiddenProcessTry}</span>
            <ul>
              <li>{configuration.translations.forbiddenProcessList1}</li>
              <li>{configuration.translations.forbiddenProcessList2}</li>
              <li>{configuration.translations.forbiddenProcessList3}</li>
            </ul>
            <span className="close-popup" onClick={closeModal}>
              &times;
            </span>
            <div className="button-popup">
              <button className="main-button" onClick={closeModal}>
                {configuration.translations.Close}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
